import { render, staticRenderFns } from "./HeroAbout.vue?vue&type=template&id=cca24b2a&"
import script from "./HeroAbout.vue?vue&type=script&lang=js&"
export * from "./HeroAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports